import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { useSelector } from 'react-redux';

import DetailTemplate from '../../common/template/DetailTemplate';
import BillPlanReplanContainer from '../../../containers/projectmng/billplan/BillPlanReplanContainer';
import BillHistoryContainer from '../../../containers/projectmng/bill_mng/BillHistoryContainer';
import { ENTRY_PROJECT } from '../../../lib/api/billReplan';

/**
 * 프로젝트/유지보수의 세금계산서 탭.
 *
 * 원가 → 계산서 계획 → 회차가 한 표에서 이어진다. 그 표 하나로 본다.
 *
 * 등록·발행요청 폼은 뺐다.
 * 계산서를 실제로 발행하고 수금을 잡는 건 세금계산서 관리 화면에서 하고,
 * 여기서는 "이 프로젝트의 계산서가 어떻게 돼 있나" 만 본다.
 * 폼을 양쪽에 두면 어디서 넣었는지에 따라 결과가 갈려 헷갈린다.
 *
 * 지난 발행 내역은 자주 볼 게 아니라 버튼으로 뺐다.
 */
const TaxBillTabTemplate = () => {
  const { project } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project,
  }));

  const [openHistory, setOpenHistory] = useState(false);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', m: 1 }}>
      <Box
        sx={{
          py: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        <Typography variant="subtitle2" color="error.main" component="div">
          받은 발주서 / 보낸 발주서를 업로드 해야 세금계산서 발행이 가능합니다.
          <br />
          작성 여부를 확인하십시오.
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Button
          variant="outlined"
          startIcon={<ReceiptLongIcon />}
          onClick={() => setOpenHistory(true)}
        >
          계산서 발행 내역
        </Button>
      </Box>

      {/* 업체 줄을 누르면 그 업체의 원가 항목과 회차가 함께 펼쳐진다. */}
      <DetailTemplate title="원가 · 계산서 현황">
        <BillPlanReplanContainer prjUuid={project?.prjUuid} entryPoint={ENTRY_PROJECT} />
      </DetailTemplate>

      <Dialog open={openHistory} onClose={() => setOpenHistory(false)} maxWidth="lg" fullWidth>
        <DialogTitle sx={{ pb: 1 }}>
          계산서 발행 내역
          <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 1.5 }}>
            {project?.cstNm}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {/* 확인용이다. 등록·삭제는 세금계산서 관리에서 한다. */}
          <BillHistoryContainer project={project} />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button variant="contained" onClick={() => setOpenHistory(false)}>닫기</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TaxBillTabTemplate;
